export default __webpack_public_path__ + "static/media/test-tube-left.fd8ba482.gif";